import {ElementType} from '@app/modules/svg/dataSource/constant/ElementType';
import {Point} from '@app/modules/svg/model/Point';
import {SVGEvent} from '@app/modules/svg/dataSource/constant/SVGEvent';
import {MoveDrawer} from '@app/modules/svg/service/tool/draw/mode/MoveDrawer';
import {MoveDrawable} from '@app/modules/svg/service/tool/draw/type/MoveDrawable';
import {SinView} from '@app/modules/svg/element/complex/cartesian/graphic/SinView';

export class DrawSin extends MoveDrawer {
  protected createDrawableElement(position: Point): MoveDrawable {
    return new SinView(
      this.drawTool.container,
      {overEvent: true, globalStyle: true, periods: 2},
      position,
      position
    );
  }

  public override start(call: boolean): void {
    super.start(call);

    if (call) {
      this.drawTool.container.__call__(SVGEvent.SIN_TOOL_ON);
    }
  }
  public override stop(call: boolean): void {
    super.stop(call);

    if (call) {
      this.drawTool.container.__call__(SVGEvent.SIN_TOOL_OFF);
    }
  }

  public _new(): DrawSin {
    return new DrawSin(this.drawTool);
  }
  public get type(): ElementType {
    return ElementType.SIN;
  }
}
